import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Toolbar,
  FormHelperText,
  Alert,
  Snackbar,
  Card,
  Chip,
  InputAdornment,
  useTheme,
  Grid,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Tooltip,
  Collapse,
  Tabs,
  Tab
} from '@mui/material';
import {
  Add as AddIcon,
  MoreVert as MoreVertIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  BorderAll,
  BorderBottom,
  Phone as PhoneIcon,
  CheckCircle as CheckCircleIcon,
  AddCircle as AddCircleIcon,
  Delete as DeleteIcon,
  PhoneCallback as PhoneCallbackIcon,
  History as HistoryIcon,
  CallEnd as CallEndIcon,
  CallMissed as CallMissedIcon,
  Create as CreateIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  FiberManualRecord as FiberManualRecordIcon,
  Warning as WarningIcon,
  DeleteOutline
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { addNewLead, updateExistingLead, createNewProposal, generateLeadProfile, deleteExistingLead } from '../../../redux/slices/leadsSlice';
import { generateProfile } from '../../../Services/GeminiUtils';
import { useNavigate } from 'react-router-dom';
import LeadForm from '../../../Components/Private/Forms/LeadForm';
import LeadProfile from '../../../Components/Private/LeadProfile';
import useMeta from '../../../hooks/useMeta';
import { fetchContactsEntries, addContactsEntry } from '../../../Services/FirebaseUtils';
import { collection, query, where, getDocs, orderBy, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { initiateLeadCall } from '../../../Services/Service';
import Proposals from './Proposals';

// Mock data - Replace with actual data from your backend
// const mockLeads = [
//   {
//     id: 1,
//     companyName: 'Tech Corp',
//     status: 'Open',
//     category: 'Hot',
//     source: 'Digital Marketing',
//     contactName: 'John Doe',
//     contactPhone: '+91 9876543210',
//     contactEmail: 'john@techcorp.com',
//     lastActionDate: '2024-01-10',
//     nextActionDate: '2024-01-15',
//     city: 'Bangalore',
//   },
//   // Add more mock data as needed
// ];

const statusOptions = ['Open', 'Closed', 'Lost'];
const categoryOptions = ['Hot', 'Warm', 'Cold'];
const sourceOptions = ['Existing Client', 'Digital Marketing', 'Inbound', 'Referral', 'Other'];

const Leads = () => {
  const dispatch = useDispatch();
  const { items: leads, loading } = useSelector((state) => state.leads);
  const userData = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const theme = useTheme();
  const { cities } = useMeta();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [assigneeFilter, setAssigneeFilter] = useState('');
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  console.log(selectedLead, "selectedLead")
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [notesDialogOpen, setNotesDialogOpen] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [noteDateTime, setNoteDateTime] = useState(new Date().toISOString().slice(0, 16));
  const [editingNoteIndex, setEditingNoteIndex] = useState(null); // To track editing note from form
  const [currentFormTypeForNote, setCurrentFormTypeForNote] = useState('add'); // 'add' or 'edit'

  // Placeholder for editing note from LeadForm
  const handleEditNoteInForm = (index, formType = 'add') => {
    setCurrentFormTypeForNote(formType); // Track if the form is for 'add' or 'edit'
    const leadData = formType === 'edit' && editLead ? editLead : newLead;

    if (leadData && leadData.notes && leadData.notes[index]) {
      const noteToEdit = leadData.notes[index];
      setNoteText(noteToEdit.note || '');
      setNoteDateTime(noteToEdit.dateTime ? noteToEdit.dateTime.slice(0, 16) : new Date().toISOString().slice(0, 16));
      setEditingNoteIndex(index); // Index within the notes array of newLead or editLeadData
      setNotesDialogOpen(true); // Open the common notes dialog
    } else {
      console.error('Note data not found for editing in form at index:', index, 'for formType:', formType, 'with leadData:', leadData);
      setSnackbar({ open: true, message: 'Cannot edit note: note data not found.', severity: 'error' });
    }
  };

  // Handle adding a note in the view dialog
  const handleAddNoteInView = () => {
    setNoteText('');
    setNoteDateTime(new Date().toISOString().slice(0, 16));
    setNotesDialogOpen(true);
  };

  const handleSaveNote = async () => {
    try {
      if (!noteText.trim()) {
        setSnackbar({ open: true, message: 'Note text cannot be empty', severity: 'error' });
        return;
      }

      const updatedLead = {
        ...viewData,
        notes: [...(viewData.notes || []), {
          dateTime: noteDateTime,
          note: noteText.trim()
        }]
      };

      await dispatch(updateExistingLead({ id: viewData.id, data: updatedLead })).unwrap();
      setNotesDialogOpen(false);
      setSnackbar({ open: true, message: 'Note added successfully', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'Error adding note: ' + error.message, severity: 'error' });
    }
  };

  const handleDeleteNote = async (index) => {
    try {
      const updatedNotes = [...(viewData.notes || [])];
      updatedNotes.splice(index, 1);

      const updatedLead = {
        ...viewData,
        notes: updatedNotes
      };

      await dispatch(updateExistingLead({ id: viewData.id, data: updatedLead })).unwrap();
      setSnackbar({ open: true, message: 'Note deleted successfully', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'Error deleting note: ' + error.message, severity: 'error' });
    }
  };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editLead, setEditLead] = useState(null);
  console.log(editLead, "editLead")
  const [isGeneratingProfile, setIsGeneratingProfile] = useState(false);
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [generatedProfile, setGeneratedProfile] = useState({});
  const [contactsData, setContactsData] = useState({}); // New state variable for contacts data
  const [selectedContacts, setSelectedContacts] = useState([]); // New state variable for selected contacts

  // New lead form state
  const [newLead, setNewLead] = useState({
    companyName: '',
    companyWebsite: '',
    status: '',
    category: '',
    source: '',
    contactName: '',
    designation: '',
    contactPhone: '',
    contactEmail: '',
    contactLinkedIn: '',
    city: '',
    lastActionDate: '',
    nextActionDate: '',
    notes: [{ note: '' }]
  });

  // Add form validation state
  const [formErrors, setFormErrors] = useState({});

  const validateForm = (lead = newLead) => {
    console.log('Validating form with data:', lead);
    const errors = {};
    // List of all mandatory fields as per new requirements
    const requiredFields = [
      'contactName',
      'contactPhone',
      'contactEmail',
      'source',
      'companyName',
      'city',
      'localities',
      'seatsNeeded',
      'requirements',
      'status',
      'category',
      'lastActionDate',
      'nextActionDate',
    ];

    console.log('Checking required fields...');
    requiredFields.forEach(field => {
      const value = lead[field];
      console.log(`Checking ${field}:`, value);
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        errors[field] = `${field} is required`;
        console.log(`${field} is missing or empty`);
      }
    });

    // Check if at least one note is provided and has content
    // console.log('Checking notes:', lead.notes);
    // if (!Array.isArray(lead.notes) || lead.notes.length === 0) {
    //   errors.notes = 'At least one note is required';
    //   console.log('Notes array is empty or invalid');
    // } else {
    //   const hasValidNote = lead.notes.some(note => 
    //     note.note && note.note.trim() !== ''
    //   );
    //   console.log('Has valid note:', hasValidNote);
    //   if (!hasValidNote) {
    //     errors.notes = 'Please provide note content';
    //   }
    // }

    setFormErrors(errors);
    const hasErrors = Object.keys(errors).length > 0;
    console.log('Validation errors:', errors);
    console.log('Form is valid:', !hasErrors);
    return !hasErrors; // Return true if there are NO errors
  };

  // Call this to reset the new lead form to its initial state
  const resetNewLeadForm = () => {
    setNewLead({
      companyName: '',
      companyWebsite: '',
      companyLinkedIn: '',
      status: '',
      category: '',
      source: '',
      contactName: '',
      designation: '',
      contactPhone: '',
      contactEmail: '',
      contactLinkedIn: '',
      city: '',
      localities: '',
      seatsNeeded: '',
      requirements: '',
      lastActionDate: '',
      nextActionDate: '',
      notes: [{ note: '' }]
    });
    setFormErrors({});
  };

  // Handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const handleCityChange = (event) => {
    setSelectedCity(event.target.value);
    setPage(0);
  };

  const handleAddDialogOpen = () => {
    setOpenAddDialog(true);
  };

  const handleAddDialogClose = () => {
    setOpenAddDialog(false);
    resetNewLeadForm();
  };

  const handleNewLeadChange = (field) => (event) => {
    setNewLead({
      ...newLead,
      [field]: event.target.value,
    });
  };

  const handleNoteChange = (idx, key, value) => {
    setNewLead(prev => {
      const notes = [...(prev.notes || [])];
      if (!notes[idx]) {
        notes[idx] = {};
      }
      notes[idx] = {
        ...notes[idx],
        [key]: value,
        dateTime: new Date().toISOString()
      };
      return { ...prev, notes };
    });
  };

  const handleAddNote = () => {
    setNewLead(prev => ({
      ...prev,
      notes: [...(prev.notes || []), { note: '', dateTime: new Date().toISOString() }]
    }));
  };

  const handleRemoveNote = (index) => {
    setNewLead(prev => ({
      ...prev,
      notes: prev.notes.filter((_, idx) => idx !== index)
    }));
  };



  const handleAddLead = async (formData) => {
    console.log("formData", formData);
    try {
      // First validate the form
      const isValid = validateForm(formData);

      if (!isValid) {

        return;
      }

      // If validation passes, add the lead
      setIsSaving(true);
      formData.owner = userData.email;
      formData.active = true;
      const result = await dispatch(addNewLead(formData)).unwrap();
      setOpenAddDialog(false);
      resetNewLeadForm(); // Reset the form after successful submission
      setSnackbar({
        open: true,
        message: 'Lead added successfully',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Error adding lead: ' + error.message,
        severity: 'error'
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleMenuOpen = (event, lead) => {
    setAnchorEl(event.currentTarget);
    setSelectedLead(lead);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedLead(null);
  };

  const handleDeleteLead = async (lead) => {
    try {
      await dispatch(deleteExistingLead(lead.id)).unwrap();
      setSnackbar({
        open: true,
        message: 'Lead deactivated successfully',
        severity: 'success'
      });
      handleMenuClose();
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Error deleting lead: ' + error.message,
        severity: 'error'
      });
      handleMenuClose();
    }
  };

  const handleEditDialogOpen = (selectedLead) => {
    console.log("lead", selectedLead);
    // Convert notes object to array format
    const formattedNotes = selectedLead.notes ?
      Object.values(selectedLead.notes).map(note => ({
        dateTime: note.dateTime,
        note: note.note
      })) : [];

    console.log("formattedNotes", formattedNotes)

    setEditLead({
      ...selectedLead,
      notes: formattedNotes,
      companyWebsite: selectedLead.companyWebsite || '',
      contactLinkedIn: selectedLead.contactLinkedIn || '',
      lastActionDate: selectedLead.lastActionDate || '',
      nextActionDate: selectedLead.nextActionDate || '',
    });
    setOpenEditDialog(true);
    handleMenuClose();
  };

  const handleEditDialogClose = () => {
    setOpenEditDialog(false);
    setEditLead(null);
    setFormErrors({});
  };

  const handleEditChange = (field) => (event) => {
    setEditLead({
      ...editLead,
      [field]: event.target.value,
    });
  };

  const handleUpdateLead = async (id, data) => {
    try {
      console.log("data", data);

      // First validate the form
      const isValid = validateForm(data);
      console.log("isValid", isValid);

      if (!isValid) {
        return;
      }

      // If validation passes, update the lead
      setIsSaving(true);
      await dispatch(updateExistingLead({ id, data })).unwrap();
      setOpenEditDialog(false);
      setSnackbar({
        open: true,
        message: 'Lead updated successfully',
        severity: 'success'
      });

    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Error updating lead: ' + error.message,
        severity: 'error'
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleCreateProposal = async (lead) => {
    try {
      handleMenuClose();
      const result = await dispatch(createNewProposal({
        companyName: lead.companyName,
        email: userData.email,
        ownerName: userData.name,
        city: lead.city,
        leadId: lead.id
      })).unwrap();
      if (result) {
        navigate(`/private/dashboard/proposals/edit/${result.proposalId}`, { state: { mode: 'edit' } });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Error creating proposal: ' + error.message,
        severity: 'error'
      });
    }
  };

  const generateCompanyProfile = async (lead) => {
    const prompt = `You are a professional business analyst tasked with creating a detailed company profile. Research and analyze "${lead.companyName}" using their official website (${lead.companyWebsite}) as your primary source.

Research Guidelines:
1. MOST IMPORTANT: Visit and thoroughly analyze their official website (${lead.companyWebsite})
2. Focus on factual, current information directly from the company's website
3. For any information not found on the website, use only these trusted sources in order of preference:
   - Company's official LinkedIn page
   - Official press releases
   - Company's official social media
   - Bloomberg or Reuters company profiles
   - Crunchbase or similar verified business databases
4. Do not include any information that cannot be verified from these sources
5. Clearly indicate the source of each piece of information

Generate a detailed company profile in markdown format with the following sections:

# Company Profile: ${lead.companyName}

## Industry & Market Position
[Describe the primary industry sector, any secondary sectors, and the company's position in these markets]

## Company Size & Scale
[Provide employee count, company scale, and any relevant size metrics]

## Core Business
- Main Business Focus: [Core business description]
- Products/Services: [List key products/services]
- Target Market: [Describe target customer segments]

## Company History
- Founded: [Year and location]
- Founders: [List key founders and their roles]
- Key Milestones: [Important company milestones]

## Office Locations
- Headquarters: [HQ location]
- Other Locations: [List other significant office locations]

## Market Overview
- Market Position: [Company's current market position]
- Unique Value Proposition: [What sets them apart]
- Key Achievements: [Notable achievements, awards]

## Recent Developments
[List any significant recent news or developments from the last 3 months]

---
Sources: [List all sources used for this profile]

Return ONLY the markdown formatted text, no additional formatting or explanation.`;

    try {
      const companyProfile = await generateProfile(prompt);
      return { success: true, profile: companyProfile, prompt };
    } catch (error) {
      console.error('Error generating company profile:', error);
      throw error;
    }
  };

  const generateContactProfile = async (lead) => {
    const prompt = `Create a profile of ${lead.contactName} who works for ${lead.companyName} with designation ${lead.designation} and generate a professional profile. Focus on their current role, experience, and decision-making capabilities.

# ${lead.contactName}

## Current Position
- Role and company
- Key responsibilities
- Duration in current role

## Professional Experience
- Previous roles and companies
- Notable achievements
- Areas of expertise
- Industry experience

## Decision Making Authority
- Level of seniority
- Scope of influence
- Budget authority indicators
- Team size (if applicable)

## Education & Certifications
- Academic background
- Professional certifications
- Relevant training

## Key Skills & Expertise
- Technical skills
- Management skills
- Industry-specific knowledge
- Notable competencies

---
Sources: [List all sources used for this profile]

Please ensure all information is factual and directly derived from credible sources to provide information. If certain information is not available, skip that section rather than making assumptions.

Format the response in clean markdown with appropriate headings and bullet points.`;

    try {
      const contactProfile = await generateProfile(prompt);
      return { success: true, profile: contactProfile, prompt };
    } catch (error) {
      console.error('Error generating contact profile:', error);
      throw error;
    }
  };

  const handleGenerateProfile = async (lead) => {
    try {
      setIsGeneratingProfile(true);
      setOpenProfileDialog(true);
      handleMenuClose();

      const [companyResult, contactResult] = await Promise.all([
        generateCompanyProfile(lead),
        generateContactProfile(lead)
      ]);

      if (!companyResult.success || !contactResult.success) {
        throw new Error('Failed to generate profiles');
      }

      const profileData = {
        company: companyResult.profile,
        contact: contactResult.profile,
        prompts: {
          companyPrompt: companyResult.prompt,
          contactPrompt: contactResult.prompt
        }
      };

      await dispatch(generateLeadProfile({ leadId: lead.id, profile: profileData })).unwrap();
      setGeneratedProfile(profileData);
      setSnackbar({
        open: true,
        message: 'Profile generated successfully',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error generating profile:', error);
      setSnackbar({
        open: true,
        message: 'Error generating profile: ' + error.message,
        severity: 'error'
      });
      setOpenProfileDialog(false);
    } finally {
      setIsGeneratingProfile(false);
    }
  };

  const handleProfileDialogClose = () => {
    setOpenProfileDialog(false);
    setGeneratedProfile({});
  };

  // New state for availability check dialog
  const [openAvailabilityDialog, setOpenAvailabilityDialog] = useState(false);
  const [availabilityData, setAvailabilityData] = useState([]);
  const [selectedInventories, setSelectedInventories] = useState([]);
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [contactRows, setContactRows] = useState([{ id: Date.now(), contact: '', phone: '', operator: '', warning: '' }]);
  const [loadingContacts, setLoadingContacts] = useState(false);

  const handleAvailabilityDialogOpen = async (lead) => {
    try {
      setLoadingContacts(true);
      // Fetch contacts data from Firestore
      const result = await fetchContactsEntries();
      if (result.success) {
        const contactsData = result.entries || [];
        console.log("Contacts Data:", contactsData);

        // Filter contacts based on lead's city
        const filteredContacts = lead.city
          ? contactsData.filter(contact => {
            // Check if contact has cities array that includes lead's city
            return contact.cities &&
              Array.isArray(contact.cities) &&
              contact.cities.includes(lead.city);
          })
          : contactsData;

        console.log("Filtered Contacts:", filteredContacts);
        setContacts(filteredContacts);

        // Always start with an empty row
        setContactRows([{
          id: Date.now(),
          contact: '',
          phone: '',
          operator: '',
          warning: ''
        }]);
      } else {
        console.error('Error fetching contacts:', result.error);
      }
    } catch (error) {
      console.error('Error in handleAvailabilityDialogOpen:', error);
    } finally {
      setLoadingContacts(false);
      setOpenAvailabilityDialog(true);
      setSelectedLead(lead); // Store the lead first
      setAnchorEl(null); // Only close the menu, don't clear selectedLead
    }
  };

  const handleAvailabilityDialogClose = () => {
    setOpenAvailabilityDialog(false);
    setAvailabilityData([]);
    setSelectedInventories([]);
    setContactRows([{ id: Date.now(), contact: '', phone: '', operator: '' }]);
  };

  const handleAddContactRow = () => {
    setContactRows([...contactRows, { id: Date.now(), contact: '', phone: '', operator: '' }]);
  };

  const handleRemoveContactRow = (id) => {
    // Don't remove if it's the only row
    if (contactRows.length <= 1) {
      return;
    }
    const updatedRows = contactRows.filter(row => row.id !== id);
    setContactRows(updatedRows);
  };

  const handleContactChange = (id, field, value) => {
    const updatedRows = contactRows.map(row => {
      if (row.id === id) {
        return { ...row, [field]: value };
      }
      return row;
    });
    setContactRows(updatedRows);
  };

  const handleContactSelect = async (id, contactId) => {
    const selectedContactData = contacts.find(c => c.id === contactId);
    if (selectedContactData) {

      // Fetch call logs first and get them directly from the function
      const logs = await fetchCallLogs(selectedLead);
      console.log("Selected Contact Data:", selectedContactData);
      console.log("Call Logs:", logs);

      // Check if this phone number exists in call logs
      let existingCall = null;
      logs?.forEach(call => {
        console.log("Call Data:", call);
        console.log("Comparing:", {
          callPhone: call.contactPhoneNumber,
          selectedPhone: selectedContactData.phone,
          match: call.contactPhoneNumber === selectedContactData.phone
        });
        if (call.contactPhoneNumber === `+91${selectedContactData.phone}`) {
          existingCall = call;
          console.log("Existing Call:", existingCall);
        }
      });
      console.log("Existing Call:", existingCall);

      const updatedRows = contactRows.map(row => {
        if (row.id === id) {
          const updatedRow = {
            ...row,
            contact: selectedContactData.name,
            phone: selectedContactData.phone,
            operator: selectedContactData.operator,
            contactId: selectedContactData.id,
            warning: existingCall ?
              `You have already initiated a call with "${selectedContactData.name} (${existingCall.operatorName})". Please check if you want to initiate a call again.` :
              ''
          };
          console.log("Updated Row:", updatedRow);
          return updatedRow;
        }
        return row;
      });
      setContactRows(updatedRows);
    }
  };

  const handleCheckAvailability = async () => {
    try {
      setCheckingAvailability(true);

      // Filter out empty rows
      const validContacts = contactRows.filter(row => row.contact && row.phone && row.operator);
      console.log("Valid Contacts:", validContacts);

      // Get existing call logs to check for duplicates
      await fetchCallLogs(selectedLead);
      const existingCalls = callLogs || [];

      console.log("Existing Calls:", existingCalls);

      if (validContacts.length === 0) {
        setSnackbar({
          open: true,
          message: 'Please add at least one valid contact',
          severity: 'error'
        });
        return;
      }

      if (!selectedLead) {
        setSnackbar({
          open: true,
          message: 'No lead selected',
          severity: 'error'
        });
        return;
      }

      // Process each contact
      for (const contact of validContacts) {
        try {
          const result = await initiateLeadCall({
            contactName: contact.contact,
            operatorName: contact.operator,
            contactPhone: contact.phone,
            requirement: selectedLead.requirements || '',
            size: selectedLead.seatsNeeded || '',
            locality: selectedLead.localities || '',
            city: selectedLead.city || '',
            id: selectedLead.id
          });

          setSnackbar({
            open: true,
            message: `Call initiated for ${contact.contact}`,
            severity: 'success'
          });

          // Fetch updated call logs
          await fetchCallLogs(selectedLead);
        } catch (error) {
          console.error('Error initiating call:', error);
          setSnackbar({
            open: true,
            message: `Failed to call ${contact.contact}: ${error.message}`,
            severity: 'error'
          });
        }
      }
    } catch (error) {
      console.error('Error in handleCheckAvailability:', error);
      setSnackbar({
        open: true,
        message: 'Error checking availability: ' + error.message,
        severity: 'error'
      });
    } finally {
      setCheckingAvailability(false);
      setOpenAvailabilityDialog(false); // Only close the dialog, don't call handleAvailabilityDialogClose
    }
  };

  // New state for call logs
  const [openCallLogsDialog, setOpenCallLogsDialog] = useState(false);
  const [callLogs, setCallLogs] = useState([]);

  // Function to fetch call logs for a lead
  const fetchCallLogs = async (lead) => {
    try {
      const leadDocRef = doc(db, 'leads', lead.id);
      const leadDoc = await getDoc(leadDocRef);

      let logs = [];
      const agentResponses = leadDoc.data()?.AgentResponses;
      const phoneNumber = agentResponses ? Object.keys(agentResponses)[0] : null;
      const agentResponseData = phoneNumber ? agentResponses[phoneNumber] : null;

      console.log("Agent Response Data:", agentResponseData);

      // Get call history logs
      if (leadDoc.exists()) {
        const data = leadDoc.data();
        const noContactCount = agentResponseData?.Nocontactestablished || 0;

        // Get call status history from the lead document
        logs = data.callStatusHistory?.map(log => ({
          ...log,
          noContactEstablished: noContactCount > 0
        })) || [];
      }
      // Check if logs array is empty
      if (logs.length === 0) {
        console.log("No call logs found for this lead");
      } else {
        console.log("Found", logs.length, "call logs");
      }

      // Update state and return logs
      setCallLogs(logs);
      return logs;
    } catch (error) {
      console.error('Error fetching call logs:', error);
      setCallLogs([]);
      return [];
    }
  };

  // Function to handle opening call logs dialog
  const handleCallLogsOpen = async (lead) => {
    setSelectedLead(lead);
    setOpenCallLogsDialog(true);

    // Show loading state
    setCallLogs([]);

    // Fetch actual call logs
    const logs = await fetchCallLogs(lead);
    setCallLogs(logs);
  };

  // Function to handle closing call logs dialog
  const handleCallLogsClose = () => {
    setOpenCallLogsDialog(false);
    setSelectedLead(null);
  };

  // Function to get status icon and color
  const getCallStatusInfo = (status, noContact = false, retry = false) => {
    if (noContact) {
      return { icon: <CallMissedIcon />, color: '#FF9800', text: 'No Contact' };
    }
    if (retry) {
      return { icon: <PhoneCallbackIcon />, color: '#9C27B0', text: 'Retry Attempted' };
    }

    switch (status?.toLowerCase()) {
      case 'completed':
        return { icon: <CheckCircleIcon />, color: '#4CAF50', text: 'Completed' };
      case 'failed':
        return { icon: <CallMissedIcon />, color: '#F44336', text: 'Failed' };
      case 'in-progress':
        return { icon: <PhoneCallbackIcon />, color: '#2196F3', text: 'In Progress' };
      case 'early-media':
        return { icon: <PhoneCallbackIcon />, color: '#FFC107', text: 'Connecting' };
      default:
        return { icon: <CallEndIcon />, color: '#757575', text: status || 'Unknown' };
    }
  };

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [viewData, setViewData] = useState(null);
  console.log(viewData, "viewData");
  const [loadingLogs, setLoadingLogs] = useState(false);

  const handleViewDialogOpen = (lead) => {
    setSelectedLead(lead);
    handleViewOpen(lead);
    handleMenuClose();
  };

  const handleViewDialogClose = () => {
    setOpenViewDialog(false);
    setViewData(null);
    setCallLogs([]);
    setLoadingLogs(false);
    setExpandedRows({});
    setActiveTab(0);
    setSelectedLead(null);
  };

  const handleViewOpen = async (lead) => {
    setViewData(lead);
    setLoadingLogs(true);
    try {
      const leadDocRef = doc(db, 'leads', lead.id);
      const leadDoc = await getDoc(leadDocRef);
      const leadData = leadDoc.data();

      console.log("Lead ID:", lead.id);
      console.log("Full Lead Data:", leadData);
      console.log("Call Status History:", leadData?.callStatusHistory);

      let logs = [];
      console.log("Lead Data:", logs)
      const agentResponses = leadDoc.data()?.AgentResponses;
      console.log("Agent Responses:", agentResponses);

      const phoneNumberList = agentResponses ? Object.keys(agentResponses) : null;
      phoneNumberList.forEach((phoneNumber) => {
        const agentResponseDataNew = agentResponses[phoneNumber];
        console.log("Agent Response Data New:", agentResponseDataNew);

      })
      const agentResponseData = phoneNumberList ? agentResponses[phoneNumberList[0]] : null;

      // Get call history logs
      if (leadDoc.exists()) {
        const data = leadDoc.data();
        const noContactCount = agentResponseData?.Nocontactestablished || 0;

        console.log("data", data);
        // Get call status history from the lead document
        logs = data.callStatusHistory?.map(log => ({
          ...log,
          noContactEstablished: noContactCount > 0
        })) || [];
        console.log("Logs:", logs);
      }

      // Check if logs array is empty
      if (logs.length === 0) {
        console.log("No call logs found for this lead");
      } else {
        console.log("Found", logs.length, "call logs");
      }

      setCallLogs(logs);
    } catch (error) {
      console.error('Error fetching call logs:', error);
      setCallLogs([]);
    }
    setLoadingLogs(false);
    setOpenViewDialog(true);
  };

  const handleViewClose = () => {
    setOpenViewDialog(false);
    setViewData(null);
    setCallLogs([]);
  };

  // State to track expanded rows in call logs
  const [expandedRows, setExpandedRows] = useState({});

  // Function to toggle expanded state
  const toggleRowExpanded = (logId) => {
    setExpandedRows(prev => ({
      ...prev,
      [logId]: !prev[logId]
    }));
  };

  // Filter leads based on search and filters
  const filteredLeads = leads.filter((lead) => {
    const matchesSearch = lead.companyName.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCity = !selectedCity || lead.city === selectedCity;
    const matchesAssignee = !assigneeFilter || lead.assignedTo === assigneeFilter;
    const basicMatches = matchesSearch && matchesCity && matchesAssignee;

    // For admin users, show all leads that match basic conditions
    if (userData.role === 'admin') {
      return basicMatches;
    }

    // For non-admin users, only show active leads that match basic conditions
    return basicMatches && lead.active === true;
  });

  // Get current page's leads
  const currentLeads = filteredLeads.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'open':
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.success.light,
        };
      case 'closed':
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.warning.light,
        };
      case 'lost':
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.error.light,
        };
      default:
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.grey[100],
        };
    }
  };

  const getCategoryColor = (category) => {
    switch (category?.toLowerCase()) {
      case 'hot':
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.error.light,
        };
      case 'warm':
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.warning.light,
        };
      case 'cold':
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.info.light,
        };
      default:
        return {
          color: theme.palette.main,
          backgroundColor: theme.palette.grey[100],
        };
    }
  };

  return (
    <Card sx={{ borderRadius: 1 }}>
      <Box sx={{ px: 2, py: 1 }}>
        <Toolbar disableGutters>
          <Box sx={{ flex: 1 }}>
            <TextField
              size="small"
              placeholder="Search leads..."
              variant="outlined"
              value={searchQuery}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ width: 300 }}
            />
          </Box>
          <Box>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddDialogOpen}
              sx={{ ml: 1 }}
            >
              Add Lead
            </Button>
          </Box>
        </Toolbar>
      </Box>
      {/* Separator Line */}
      <Box sx={{
        height: "1px",
        backgroundColor: "#e0e0e0",
        width: "calc(100% + 32px)",
        mx: -2,
        mb: 2
      }} />
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: (theme) => `${theme.palette.primary.main}08` }}>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>Company Name</TableCell>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>Status</TableCell>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>Category</TableCell>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>Contact</TableCell>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>City</TableCell>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>Last Action</TableCell>
              <TableCell sx={{
                fontWeight: 500,
                color: "#6B7280",
                borderBottom: "1px solid #E5E7EB",
                py: 1.5
              }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentLeads
              .map((lead) => (
                <TableRow
                  key={lead.id}
                  hover
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <Typography variant="body1">{lead.companyName}</Typography>
                  </TableCell>
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <Chip
                      label={lead.status}
                      size="small"
                      sx={getStatusColor(lead.status)}
                    />
                  </TableCell>
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <Chip
                      label={lead.category}
                      size="small"
                      sx={getCategoryColor(lead.category)}
                    />
                  </TableCell>
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <Typography variant="body2">{lead.contactName}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {lead.contactEmail}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <Typography variant="body2">{lead.city}</Typography>
                  </TableCell>
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <Typography variant="body2">{new Date(lead.lastActionDate).toLocaleDateString()}</Typography>
                  </TableCell>
                  <TableCell sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    py: 1.5
                  }}>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMenuOpen(e, lead);
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredLeads.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/* Add Lead Dialog */}
      <Dialog open={openAddDialog} onClose={handleAddDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Add New Lead</DialogTitle>
        <DialogContent>
          <LeadForm
            lead={newLead}
            handleChange={handleNewLeadChange}
            onNoteChange={handleNoteChange}
            onAddNote={handleAddNote}
            onRemoveNote={handleRemoveNote}
            onEditNote={handleEditNoteInForm} // Added new prop
            formErrors={formErrors}
            statusOptions={statusOptions}
            categoryOptions={categoryOptions}
            sourceOptions={sourceOptions}
            cityOptions={cities}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddDialogClose}>Cancel</Button>
          <Button onClick={() => handleAddLead(newLead)} variant="contained">Add Lead</Button>
        </DialogActions>
      </Dialog>

      {/* Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          handleMenuClose();
          handleEditDialogOpen(selectedLead);
        }}>
          <ListItemIcon>
            <BorderAll fontSize="small" />
          </ListItemIcon>
          Edit
        </MenuItem>
        <MenuItem onClick={() => {
          handleMenuClose();
          handleDeleteLead(selectedLead);
        }}>
          <ListItemIcon>
            <DeleteOutline fontSize="small" />
          </ListItemIcon>
          Delete
        </MenuItem>
        <MenuItem onClick={() => {
          handleMenuClose();
          handleViewDialogOpen(selectedLead);
        }}>
          <ListItemIcon>
            <HistoryIcon fontSize="small" />
          </ListItemIcon>
          View Details
        </MenuItem>
        <MenuItem onClick={() => {
          handleMenuClose();
          handleGenerateProfile(selectedLead);
        }}>
          <ListItemIcon>
            <BorderBottom fontSize="small" />
          </ListItemIcon>
          Generate Profile
        </MenuItem>
        <MenuItem onClick={() => {
          handleMenuClose();
          handleCreateProposal(selectedLead);
        }}>
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Create Proposal
        </MenuItem>
        <MenuItem onClick={() => {
          handleMenuClose();
          handleAvailabilityDialogOpen(selectedLead);
        }}>
          <ListItemIcon>
            <PhoneIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Check Availablity" />
        </MenuItem>
      </Menu>

      {/* View Details Dialog */}
      <Dialog
        open={openViewDialog}
        onClose={handleViewDialogClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Lead Details</DialogTitle>
        <DialogContent>
          {viewData && (
            <Box sx={{ width: '100%' }}>
              {/* Tabs */}
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs
                  value={activeTab}
                  onChange={(e, newValue) => setActiveTab(newValue)}
                  aria-label="lead details tabs"
                  sx={{
                    '& .MuiTab-root': {
                      textTransform: 'none',
                      fontSize: '16px',
                      fontWeight: 500,
                      minWidth: '120px',
                      py: 2
                    },
                    '& .Mui-selected': {
                      color: 'primary.main',
                      fontWeight: 600
                    }
                  }}
                >
                  <Tab label="Lead Details" />
                  <Tab label="Availability Check" />
                  <Tab label="Proposals" />
                </Tabs>
              </Box>

              {/* Tab 1: Lead Details */}

              {activeTab === 0 && (
                
                <Box sx={{ p: 2 }}>

                  {/* Contact Information */}

                  <Typography variant="h6" gutterBottom>Contact Information</Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" color="textSecondary">Name</Typography>
                      <Typography>{viewData.contactName}</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" color="textSecondary">CompanyName</Typography>
                      <Typography>{viewData.companyName || 'Not Assigned'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" color="textSecondary">PhoneNumber</Typography>
                      <Typography>{viewData.contactPhone}</Typography>
                    </Grid>
                  </Grid>

                  {/* Requirements */}
                  <Typography variant="h6" gutterBottom>Requirements</Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>

                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">City</Typography>
                      <Typography>{viewData.city || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">Locality</Typography>
                      <Typography>{viewData.localities || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">SeatsNeeded</Typography>
                      <Typography>{viewData.seatsNeeded || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">Requirements</Typography>
                      <Typography>{viewData.requirements || '-'}</Typography>
                    </Grid>
                  </Grid>

                  <Typography variant="h6" gutterBottom>Lead Status</Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>

                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                      <Typography>{viewData.status || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">Category</Typography>
                      <Typography>{viewData.category || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">LastActionDate</Typography>
                      <Typography>{viewData.lastActionDate || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="subtitle2" color="textSecondary">NextActionDate</Typography>
                      <Typography>{viewData.nextActionDate || '-'}</Typography>
                    </Grid>
                  </Grid>

                  <Typography variant="h6" gutterBottom>Notes</Typography>

                  <Box sx={{ mt: 3 }}>
                    {viewData.notes && (Array.isArray(viewData.notes) ? viewData.notes : Object.values(viewData.notes)).length > 0 ? (
                      <TableContainer component={Paper} sx={{ mb: 2 }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: (theme) => `${theme.palette.primary.main}08` }}>
                              <TableCell sx={{ fontWeight: 500, color: "#6B7280", borderBottom: "1px solid #E5E7EB", py: 1.5 }}>Date/Time</TableCell>
                              <TableCell sx={{ fontWeight: 500, color: "#6B7280", borderBottom: "1px solid #E5E7EB", py: 1.5 }}>Note</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(Array.isArray(viewData.notes) ? viewData.notes : Object.values(viewData.notes)).map((note, index) => (
                              <TableRow key={index}>
                                <TableCell sx={{ borderBottom: "1px solid #E5E7EB", color: "#111827", py: 1.5, verticalAlign: 'top' }}>
                                  {new Date(note.dateTime).toLocaleString()}
                                </TableCell>
                                <TableCell sx={{ borderBottom: "1px solid #E5E7EB", color: "#111827", py: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word', verticalAlign: 'top' }}>
                                  {note.note}
                                </TableCell>

                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Typography variant="body2" color="textSecondary" align="center" sx={{ py: 2 }}>
                        No notes available
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}

              {/* Tab 2: Availability Check */}
              {activeTab === 1 && (

                <Box sx={{
                  p: 2,
                  height: '400px',  // Fixed height
                  overflowY: 'auto'  // Enable vertical scrolling
                }}>
                  {/* Call Logs */}
                  <Typography variant="h6" gutterBottom>Call Logs</Typography>
                  <Box sx={{ mt: 2 }}>
                    {loadingLogs ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                      </Box>
                    ) : callLogs.length === 0 ? (
                      <Typography variant="body1" color="textSecondary" align="center">
                        No call logs found for this lead
                      </Typography>
                    ) : (
                      <TableContainer component={Paper} elevation={0}>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: (theme) => `${theme.palette.primary.main}08` }}>
                              <TableCell sx={{
                                fontWeight: 500,
                                color: "#6B7280",
                                borderBottom: "1px solid #E5E7EB",
                                py: 1.5,
                                width: '30%'
                              }}>Name</TableCell>
                              <TableCell sx={{
                                fontWeight: 500,
                                color: "#6B7280",
                                borderBottom: "1px solid #E5E7EB",
                                py: 1.5,
                                width: '30%'
                              }}>Operator</TableCell>
                              <TableCell sx={{
                                fontWeight: 500,
                                color: "#6B7280",
                                borderBottom: "1px solid #E5E7EB",
                                py: 1.5,
                                width: '30%'
                              }}>Call Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {/* Group logs by phone number to avoid duplicates */}
                            {Object.values(
                              callLogs.reduce((acc, log) => {
                                console.log("log", log);
                                const phoneKey = log.contactPhoneNumber || 'unknown';
                                if (!acc[phoneKey]) {
                                  // Get the noContactEstablished value for this phone number
                                  const agentResponseData = viewData?.AgentResponses?.[phoneKey];
                                  const noContactCount = agentResponseData?.Nocontactestablished || 0;

                                  acc[phoneKey] = {
                                    noContactEstablished: noContactCount > 0,
                                    phoneNumber: log.contactPhoneNumber,
                                    contactName: log.contactName,
                                    operatorName: log.operatorName,
                                    allLogs: log.callLog || []
                                  };
                                }
                                return acc;
                              }, {})
                            ).map((logGroup, index) => {
                              console.log("logGroup", logGroup);
                              const logId = `log-${index}`;
                              const isExpanded = expandedRows[logId] || false;


                              return (
                                <React.Fragment key={logId}>
                                  <TableRow
                                    hover
                                    //
                                    sx={{
                                      cursor: 'pointer',
                                      '&:hover': { backgroundColor: '#f5f5f5' },
                                      borderLeft: '4px solid #4CAF50'
                                    }}
                                  >
                                    <TableCell>
                                      <Typography variant="body2">
                                        {logGroup.contactName || 'N/A'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2">
                                        {logGroup.operatorName || 'N/A'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Button
                                          variant="contained"
                                          size="small"
                                          disabled={!logGroup.allLogs.some(log => log.callStatus === 'completed')}
                                          onClick={() => toggleRowExpanded(logId)}
                                          sx={{
                                            display: logGroup.allLogs.some(log => log.callStatus === 'completed') ? 'inline-flex' : 'none',
                                            borderRadius: '20px',
                                            textTransform: 'none',
                                            minWidth: '90px',
                                            backgroundColor: '#4CAF50',
                                            '&:hover': {
                                              backgroundColor: '#45a049'
                                            },
                                            '&.Mui-disabled': {
                                              backgroundColor: '#a5d6a7',
                                              color: 'white'
                                            }
                                          }}
                                        >
                                          Completed
                                          {expandedRows[logId] ?
                                            <KeyboardArrowUpIcon sx={{ ml: 0.5 }} /> :
                                            <KeyboardArrowDownIcon sx={{ ml: 0.5 }} />}
                                        </Button>
                                        <Button
                                          variant="contained"
                                          size="small"
                                          onClick={() => toggleRowExpanded(logId)}
                                          disabled={!logGroup.noContactEstablished && !logGroup.allLogs.some(log => log.callStatus === 'failed')}
                                          sx={{
                                            display: logGroup.noContactEstablished || logGroup.allLogs.some(log => log.callStatus === 'failed') ? 'inline-flex' : 'none',
                                            borderRadius: '20px',
                                            textTransform: 'none',
                                            minWidth: '90px',
                                            backgroundColor: '#F44336',
                                            '&:hover': {
                                              backgroundColor: '#d32f2f'
                                            },
                                            '&.Mui-disabled': {
                                              backgroundColor: '#ef9a9a',
                                              color: 'white'
                                            }
                                          }}
                                        >
                                          Failed
                                          {expandedRows[logId] ?
                                            <KeyboardArrowUpIcon sx={{ ml: 0.5 }} /> :
                                            <KeyboardArrowDownIcon sx={{ ml: 0.5 }} />}
                                        </Button>
                                      </Box>
                                    </TableCell>
                                  </TableRow>

                                  {/* Expanded Details */}
                                  <TableRow>
                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                        <Box sx={{ p: 2, backgroundColor: '#fafafa' }}>
                                          {/* User Response Section */}
                                          {logGroup.allLogs.some(log => log.userResponse && log.callStatus === 'completed') && (
                                            <Box sx={{ mb: 3 }}>
                                              <Typography variant="subtitle2" gutterBottom component="div">
                                                User Response
                                              </Typography>
                                              <Box sx={{ ml: 2 }}>
                                                {logGroup.allLogs
                                                  .filter(log => log.userResponse && log.callStatus === 'completed')
                                                  .map((log, idx) => (
                                                    <List key={idx} dense sx={{ bgcolor: 'background.paper', borderRadius: 1, mt: 1 }}>
                                                      <ListItem>
                                                        <ListItemIcon>
                                                          <CheckCircleIcon fontSize="small" color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={log.userResponse} />
                                                      </ListItem>
                                                    </List>
                                                  ))}
                                              </Box>
                                            </Box>
                                          )}

                                          <Typography variant="subtitle2" gutterBottom component="div">
                                            Call Status History
                                          </Typography>

                                          {/* Call Status Timeline */}
                                          <Box sx={{ ml: 2, mb: 3 }}>
                                            {logGroup.allLogs.map((log, idx) => (
                                              <Box
                                                key={idx}
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'flex-start',
                                                  mb: 1,
                                                  position: 'relative',
                                                  '&:not(:last-child)::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: '10px',
                                                    top: '20px',
                                                    bottom: '-10px',
                                                    width: '2px',
                                                    backgroundColor: '#e0e0e0'
                                                  }
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    width: 20,
                                                    height: 20,
                                                    borderRadius: '50%',
                                                    backgroundColor:
                                                      log.callStatus === 'completed' ? '#4CAF50' :
                                                        log.callStatus === 'failed' ? '#F44336' :
                                                          log.callStatus === 'retry-initiated' ? '#FF9800' :
                                                            '#2196F3',
                                                    mr: 2,
                                                    zIndex: 1
                                                  }}
                                                />
                                                <Box sx={{ flex: 1 }}>
                                                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                      {log.callStatus?.toLowerCase()
                                                        .split('-')
                                                        .map((word, index) =>
                                                          index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) :
                                                            word.charAt(0).toUpperCase() + word.slice(1)
                                                        )
                                                        .join(' ')}
                                                      {log.noContactEstablished && ' (No Contact)'}
                                                    </Typography>
                                                    <Typography variant="caption" color="textSecondary">
                                                      {new Date(log.updateTime).toLocaleString()}
                                                    </Typography>
                                                  </Box>

                                                  {/* Call Details */}

                                                </Box>
                                              </Box>
                                            ))}
                                          </Box>
                                        </Box>
                                      </Collapse>
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                </Box>
              )}

              {/* Tab 3: Proposals */}
              {activeTab === 2 && (
                <Box sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom>Proposals</Typography>
                  {viewData && (
                    <Proposals
                      leadId={viewData.id}
                      showToolbar={false}
                      showPagination={false}
                      maxHeight={400}
                    />
                  )}
                </Box>
              )}
            </Box>
          )}



        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Edit Lead Dialog */}
      <Dialog open={openEditDialog} onClose={handleEditDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Edit Lead</DialogTitle>
        <DialogContent>
          {editLead && (
            <LeadForm
              lead={editLead}
              handleChange={handleEditChange}
              onNoteChange={(index, key, value) => handleNoteChange(index, key, value, 'edit')}
              onAddNote={() => handleAddNote('edit')}
              onRemoveNote={(index) => handleRemoveNote(index, 'edit')}
              onEditNote={(index) => handleEditNoteInForm(index, 'edit')}
              formErrors={formErrors}
              statusOptions={statusOptions}
              categoryOptions={categoryOptions}
              sourceOptions={sourceOptions}
              cityOptions={cities}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose}>Cancel</Button>
          <Button onClick={() => handleUpdateLead(editLead.id, editLead)} variant="contained" color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profile Dialog */}
      <LeadProfile
        open={openProfileDialog}
        onClose={handleProfileDialogClose}
        profile={generatedProfile}
        loading={isGeneratingProfile}
      />

      {/* Availability Dialog */}
      <Dialog open={openAvailabilityDialog} onClose={handleAvailabilityDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Check Availability</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
            {loadingContacts ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {contactRows.map((row) => (
                  <Paper key={row.id} elevation={0} sx={{ p: 2 }}>
                    <Grid container spacing={2} key={row.id} style={{ marginBottom: '8px' }} alignItems="center">
                      <Grid item xs={12} sm={5}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Contact Name</InputLabel>
                          <Select
                            value={row.contact || ''}
                            onChange={(e) => {
                              const selectedContact = contacts.find(c => c.name === e.target.value);
                              if (selectedContact) {
                                handleContactSelect(row.id, selectedContact.id);
                              }
                            }}
                            label="Contact Name"
                          >
                            <MenuItem value="">
                              <em>Select a contact</em>
                            </MenuItem>
                            {contacts.map((contact) => (
                              <MenuItem
                                key={contact.id}
                                value={contact.name}
                              >
                                {contact.name} {contact.operator ? `(${contact.operator})` : ''}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextField
                          fullWidth
                          disabled
                          label="Phone Number"
                          variant="outlined"
                          size="small"
                          value={row.phone || ''}
                        />
                      </Grid>

                      <Grid item xs={12} sm={2}>
                        <IconButton
                          color="error"
                          onClick={() => handleRemoveContactRow(row.id)}
                          disabled={contactRows.length <= 1}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                      {row.warning && (
                        <Grid item xs={12}>
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                            <WarningIcon color="warning" sx={{ mr: 1 }} />
                            <FormHelperText
                              sx={{
                                padding: '2px 12px',
                                borderRadius: '4px',
                                border: '#f2cc94 solid 1px',
                                color: theme => theme.palette.warning.dark,
                                backgroundColor: '#f2cc94',

                                fontSize: '0.875rem',
                                m: 0
                              }}
                            >
                              {row.warning}
                            </FormHelperText>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                ))}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <Button
                    startIcon={<AddCircleIcon />}
                    onClick={handleAddContactRow}
                    color="primary"
                  >
                    Add More
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAvailabilityDialogClose}>Cancel</Button>
          <Button
            onClick={handleCheckAvailability}
            variant="contained"
            color="primary"
            disabled={checkingAvailability || contactRows.every(row => !row.contact || !row.phone)}
            startIcon={checkingAvailability ? <CircularProgress size={20} color="inherit" /> : <PhoneIcon />}
          >
            {checkingAvailability ? 'Checking...' : 'Check Availability'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card >
  );
};

export default Leads;
